<template>
<div v-if="list && list.length">
    <bread-crumb :vector="[{fa : name,path : '/Category/Home/'+route.params.id}]" />
    <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5">
        <div>
        <div class="sc-d8w7bo-1 jpdybm">
            <div class="d-flex flex-wrap" style="padding-inline: 3px;gap: 1px;" >
            <product-border :list="list" />
            </div>
        </div>
        </div>
    </section>
</div>
<Loading v-else page="group" />

</template>
    
<script setup>
import {ref} from 'vue'
import {useRoute} from 'vue-router';
import BreadCrumb from "@/components/section/item/BreadCrumb.vue";
import ProductBorder from '@/components/section/item/ProductBorder.vue';
import Loading from "../../../../section/item/loading.vue";

let route = useRoute()
let list = ref([]);
let name = ref('');
getItems()
async function getItems(){
    let response = await fetch(`https://radap.ir/Backend/api/section/pages/main/main_whole.php?id=${route.params.id}`)
    let data = await response.json()
    list.value = data.items;
    name.value = data.name;
    window.scrollTo(0,0)
}
</script>
    